function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Link, styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate, Link as NavigateLink } from 'react-router-dom';
import { Localization } from '../Localization';
import { Account, LoginForm, SocialNetworks, ToggleStyled } from '../components';
import { CheckboxField, PasswordFieldByConfig, TextFormFieldByConfig } from '../components/FormFields';
import { PhoneFieldByConfig } from '../components/FormFields/PhoneFieldByConfig';
import { MessageType, MessageBox } from '../components/MessageBox';
import { defaultTranslations } from '../constants/defaultTranslations';
import { useConfiguration } from '../contexts';
import { useAdLogin, useKeyPress } from '../hooks';
import { MessageStatus, TranslationKey } from '../models';
import { getConfigurationClientId, isMobileDevice } from '../utils';
import { isFIDOSupported, isUserVerifyingPlatformAuthenticatorAvailable } from '../utils/passwordless/helpers';
import { tryPasswordlessSignIn, handlePasswordlessSignIn } from '../utils/passwordless/passwordless.login';
import { useSafeUrl } from '../utils/useSafeUrl';
var SignInStyled = styled(Typography)(function() {
    return {
        fontSize: '25px',
        fontWeight: 'bold',
        userSelect: 'none'
    };
});
var LinkStyled = styled(Link)(function() {
    return {
        fontSize: '12px',
        cursor: 'pointer'
    };
});
var JoinUsLink = styled(Link)(function() {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    };
});
var ErrorStatusStyled = styled('div')(function(param) {
    var theme = param.theme;
    return {
        marginBottom: theme.spacing(2),
        fontSize: '14px',
        color: theme.palette.error.main
    };
});
var getConfigurationStatus = function(status) {
    switch(status){
        case MessageStatus.InvalidUsernameOrPassword:
            return /*#__PURE__*/ _jsx(ErrorStatusStyled, {
                children: /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: defaultTranslations.errUsernameOrPassword,
                    id: TranslationKey.errUsernameOrPassword
                })
            });
        case MessageStatus.UserLockedOut:
            return /*#__PURE__*/ _jsx(ErrorStatusStyled, {
                children: /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: defaultTranslations.errUserLockedOut,
                    id: TranslationKey.errUserLockedOut
                })
            });
        case MessageStatus.UserNotAllowed:
            return /*#__PURE__*/ _jsx(ErrorStatusStyled, {
                children: /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: defaultTranslations.errUserNotAllowed,
                    id: TranslationKey.errUserNotAllowed
                })
            });
        default:
            return null;
    }
};
var Login = function(param) {
    var isPhoneInput = param.isPhoneInput, handleSignInInput = param.handleSignInInput;
    var _externalProviders_;
    var getTestId = useTestId().getTestId;
    var formRef = useRef(null);
    var _useConfiguration = useConfiguration(), returnUrl = _useConfiguration.returnUrl, antiForgeryToken = _useConfiguration.antiForgeryToken, tenant = _useConfiguration.tenant, identityUrl = _useConfiguration.identityUrl, externalProviders = _useConfiguration.externalProviders, onlineBaseUrl = _useConfiguration.onlineBaseUrl, clientId = _useConfiguration.clientId, status = _useConfiguration.status, userName = _useConfiguration.userName, _useConfiguration_allowRememberLogin = _useConfiguration.allowRememberLogin, allowRememberLogin = _useConfiguration_allowRememberLogin === void 0 ? true : _useConfiguration_allowRememberLogin, _useConfiguration_allowPasswordless = _useConfiguration.allowPasswordless, allowPasswordless = _useConfiguration_allowPasswordless === void 0 ? false : _useConfiguration_allowPasswordless;
    var _useFormContext = useFormContext(), watch = _useFormContext.watch, reset = _useFormContext.reset, isValid = _useFormContext.formState.isValid, handleSubmit = _useFormContext.handleSubmit;
    var _useState = _sliced_to_array(useState(false), 2), isSubmitting = _useState[0], setIsSubmitting = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), ssoLoginCalled = _useState1[0], setSsoLoginCalled = _useState1[1];
    var authenticationScheme = 'ActiveDirectory';
    var paramsObj = {
        scheme: authenticationScheme,
        returnUrl: returnUrl
    };
    var urlParameters = new URLSearchParams(paramsObj).toString();
    var ssoAdLoginUrl = new URL("External/Challenge?".concat(urlParameters), identityUrl).toString();
    var onlyAdProvider = externalProviders.length === 1 && ((_externalProviders_ = externalProviders[0]) === null || _externalProviders_ === void 0 ? void 0 : _externalProviders_.displayName.toLowerCase()) === 'activedirectory';
    var _watch;
    var loginName = (_watch = watch('LoginName')) !== null && _watch !== void 0 ? _watch : userName;
    var _watch1;
    var loginPhone = (_watch1 = watch('LoginPhone')) !== null && _watch1 !== void 0 ? _watch1 : userName;
    var passwordInput = watch('Password');
    var keepMeSignInInput = watch('RememberLogin');
    var isMobile = isMobileDevice();
    var handleTouchAdLogin = useAdLogin(ssoAdLoginUrl, 8, 500).handleTouchAdLogin;
    var _getConfigurationClientId = getConfigurationClientId(clientId), isBackButtonDisplayed = _getConfigurationClientId.isBackButtonDisplayed, isJoinUsButtonDisplayed = _getConfigurationClientId.isJoinUsButtonDisplayed;
    var navigate = useNavigate();
    var urlParams = {
        ReturnUrl: returnUrl
    };
    var newParams = new URLSearchParams(urlParams).toString();
    var loginUrl = new URL("Account/Login?".concat(newParams), identityUrl);
    useEffect(function() {
        if (isPhoneInput) {
            localStorage.setItem('isPhoneField', 'true');
        } else {
            localStorage.removeItem('isPhoneField');
        }
    }, [
        isPhoneInput
    ]);
    var _useState2 = _sliced_to_array(useState(''), 2), message = _useState2[0], setMessage = _useState2[1];
    var _useState3 = _sliced_to_array(useState(MessageType.Info), 2), messageType = _useState3[0], setMessageType = _useState3[1];
    var _useState4 = _sliced_to_array(useState(2000), 2), messageTimeout = _useState4[0], setMessageTimeout = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), trigger = _useState5[0], setTrigger = _useState5[1];
    var _useState6 = _sliced_to_array(useState(Promise.resolve()), 2), tryPasswordlessSignInPromise = _useState6[0], setTryPasswordlessSignInPromise = _useState6[1];
    var _useState7 = _sliced_to_array(useState(new AbortController()), 1), abortController = _useState7[0];
    var messageBox = /*#__PURE__*/ _jsx(MessageBox, {
        message: message,
        type: messageType,
        timeout: messageTimeout,
        trigger: trigger
    });
    var showMessage = useCallback(function(message, type) {
        var timeoutMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2000;
        setMessage(message);
        setMessageType(type);
        setMessageTimeout(timeoutMs);
        setTrigger(function(t) {
            return t + 1;
        });
    }, []);
    useEffect(function() {
        var CheckPasswordlessOnLoad = function CheckPasswordlessOnLoad() {
            return _CheckPasswordlessOnLoad.apply(this, arguments);
        };
        function _CheckPasswordlessOnLoad() {
            _CheckPasswordlessOnLoad = _async_to_generator(function() {
                var isSupported, success, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                isUserVerifyingPlatformAuthenticatorAvailable()
                            ];
                        case 1:
                            isSupported = _state.sent();
                            if (!isSupported) {
                                console.log('User Verifying Platform Authenticator is not available');
                                // ToDo: hide the passwordless login button
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                tryPasswordlessSignIn(abortController)
                            ];
                        case 2:
                            success = _state.sent();
                            if (success) {
                                if (returnUrl) {
                                    window.location.href = returnUrl;
                                } else {
                                    window.location.href = '/';
                                }
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error('TryPasswordlessSignIn error: ', error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _CheckPasswordlessOnLoad.apply(this, arguments);
        }
        setTryPasswordlessSignInPromise(CheckPasswordlessOnLoad());
    }, [
        abortController,
        returnUrl
    ]);
    var handleNavForgoten = useCallback(function() {
        reset({
            Password: '',
            LoginName: loginName,
            LoginPhone: loginPhone
        });
        navigate({
            pathname: '/forgotpassword',
            search: newParams
        }, {
            state: {
                isPhoneInput: isPhoneInput,
                urlParams: newParams
            }
        });
    }, [
        reset,
        loginName,
        loginPhone,
        navigate,
        newParams,
        isPhoneInput
    ]);
    var safeOnlineBaseUrl = useSafeUrl(onlineBaseUrl, 'ssoidentity/register');
    var handleJoinUsRedirect = useCallback(function() {
        window.location.replace(safeOnlineBaseUrl);
    }, [
        safeOnlineBaseUrl
    ]);
    var handleDesktopSsoAdLogin = useCallback(function(event) {
        if ((event.ctrlKey || event.metaKey) && !ssoLoginCalled) {
            window.location.href = ssoAdLoginUrl;
            setSsoLoginCalled(true);
        }
    }, [
        ssoAdLoginUrl,
        ssoLoginCalled
    ]);
    var handleSsoAdLogin = useCallback(function(event) {
        if (isMobile) {
            handleTouchAdLogin();
        } else {
            handleDesktopSsoAdLogin(event);
        }
    }, [
        isMobile,
        handleTouchAdLogin,
        handleDesktopSsoAdLogin
    ]);
    var handleSubmitForm = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _formRef_current;
        return _ts_generator(this, function(_state) {
            if (isSubmitting) {
                return [
                    2
                ];
            }
            setIsSubmitting(true);
            try {
                ;
                (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.submit();
            } catch (error) {
                console.error(error);
            }
            return [
                2
            ];
        });
    }), [
        isSubmitting
    ]);
    var handlePasswordlessSubmit = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var username, success, error_, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (isSubmitting) {
                            return [
                                2
                            ];
                        }
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        abortController.abort();
                        console.log('Waiting for conditional sign-in to abort');
                        return [
                            4,
                            tryPasswordlessSignInPromise
                        ];
                    case 2:
                        _state.sent();
                        username = loginName;
                        if (username) {
                            if (!username.includes('\\') && tenant) {
                                username = "".concat(tenant, "\\").concat(username);
                            }
                            username = username.toUpperCase();
                        }
                        return [
                            4,
                            handlePasswordlessSignIn(username)
                        ];
                    case 3:
                        success = _state.sent();
                        if (success) {
                            if (returnUrl) {
                                window.location.href = returnUrl;
                            } else {
                                window.location.href = '/';
                            }
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error_ = _state.sent();
                        error = error_;
                        if (error instanceof DOMException && error.name === 'NotAllowedError') {
                            showMessage('Login cancelled', MessageType.Info, 1000);
                        } else {
                            console.error(e);
                            console.error("Error ".concat(error.name, ": ").concat(error.message));
                            showMessage(error.message, MessageType.Error, 5000);
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setIsSubmitting(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isSubmitting,
        loginName,
        tenant,
        returnUrl,
        showMessage,
        abortController,
        tryPasswordlessSignInPromise
    ]);
    var handleEnterPress = function() {
        handleSubmitForm();
    };
    useKeyPress('Enter', isValid, handleEnterPress);
    useEffect(function() {
        var form = formRef.current;
        if (form) {
            var onSubmit = function(e) {
                if (isSubmitting) {
                    e.preventDefault();
                }
            };
            form.addEventListener('submit', onSubmit);
            return function() {
                form.removeEventListener('submit', onSubmit);
            };
        }
        return undefined;
    }, [
        isSubmitting
    ]);
    var usernameField = /*#__PURE__*/ _jsx(TextFormFieldByConfig, {
        name: "LoginName",
        value: loginName,
        label: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.MemberNumberOrEmail,
            id: TranslationKey.MemberNumberOrEmail
        }),
        tooltipText: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.memberOrEmailTooltip,
            id: TranslationKey.memberOrEmailTooltip
        }),
        autocomplete: "username webauthn"
    });
    var passwordField = /*#__PURE__*/ _jsx(PasswordFieldByConfig, {
        name: "Password",
        label: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.Password,
            id: TranslationKey.Password
        }),
        errorLabel: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.enterPassword,
            id: TranslationKey.enterPassword
        })
    });
    var phoneField = /*#__PURE__*/ _jsx(PhoneFieldByConfig, {
        name: "LoginPhone",
        value: loginPhone,
        inputMode: 'tel',
        label: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.MobilePhone,
            id: TranslationKey.MobilePhone
        }),
        tooltipText: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.mobilePhoneTooltip,
            id: TranslationKey.mobilePhoneTooltip
        }),
        tooltipWithPrefix: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.mobilePhoneTooltipPhoneWithPrefix,
            id: TranslationKey.mobilePhoneTooltipPhoneWithPrefix
        })
    });
    var keepMeSignIn = /*#__PURE__*/ _jsx(CheckboxField, {
        name: "RememberLogin",
        label: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.KeepMeSignIn,
            id: TranslationKey.KeepMeSignIn
        }),
        color: "primary",
        disabled: false,
        value: keepMeSignInInput,
        inputProps: {
            'data-testid': getTestId("checkbox-field")
        },
        tooltipText: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.keepMeSignInTooltip,
            id: TranslationKey.keepMeSignInTooltip
        })
    });
    var loginWithPhone = isPhoneInput ? /*#__PURE__*/ _jsx(Localization, {
        defaultMessage: defaultTranslations.SignInWithMemberOrEmail,
        id: TranslationKey.SignInWithMemberOrEmail
    }) : /*#__PURE__*/ _jsx(Localization, {
        defaultMessage: defaultTranslations.SignWithMobilePhone,
        id: TranslationKey.SignWithMobilePhone
    });
    var loginFormProps = {
        formRef: formRef,
        loginUrl: loginUrl,
        userName: userName,
        password: passwordInput,
        keepMeSign: keepMeSignInInput,
        antiForgeryToken: antiForgeryToken,
        tenant: tenant,
        returnUrl: returnUrl,
        name: 'new-password-signin-button',
        submitTitle: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.SignIn,
            id: TranslationKey.SignIn
        }),
        passwordlessTitle: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.PasswordlessSignIn,
            id: TranslationKey.PasswordlessSignIn
        }),
        isPasswordlessVisible: allowPasswordless && isFIDOSupported()
    };
    return /*#__PURE__*/ _jsxs(Account, {
        title: /*#__PURE__*/ _jsx(SignInStyled, {
            "data-testid": getTestId('sign-in-title'),
            onClick: handleSsoAdLogin,
            children: /*#__PURE__*/ _jsx(Localization, {
                defaultMessage: defaultTranslations.SignInTitle,
                id: TranslationKey.SignInTitle
            })
        }),
        isLoginPage: Boolean(true),
        showBackBtn: isBackButtonDisplayed,
        children: [
            /*#__PURE__*/ _jsx(NavigateLink, {
                to: "/passwordlessregister"
            }),
            getConfigurationStatus(status),
            isPhoneInput ? phoneField : usernameField,
            /*#__PURE__*/ _jsx(Grid, {
                mt: 1,
                mb: 5,
                children: /*#__PURE__*/ _jsx(ToggleStyled, {
                    "data-testid": isPhoneInput ? getTestId('signin-with-number') : getTestId('signin-with-phone'),
                    onClick: function() {
                        return handleSignInInput(!isPhoneInput);
                    },
                    children: loginWithPhone
                })
            }),
            passwordField,
            /*#__PURE__*/ _jsx(Grid, {
                mt: 1,
                mb: 2,
                children: /*#__PURE__*/ _jsx(LinkStyled, {
                    variant: "body1",
                    "data-testid": getTestId('forgot-password'),
                    onClick: function() {
                        return handleNavForgoten();
                    },
                    children: /*#__PURE__*/ _jsx(Localization, {
                        defaultMessage: defaultTranslations.ForgotYourPassword,
                        id: TranslationKey.ForgotYourPassword
                    })
                })
            }),
            allowRememberLogin ? keepMeSignIn : null,
            /*#__PURE__*/ _jsx(LoginForm, _object_spread_props(_object_spread({}, loginFormProps), {
                name: "login-signIn-button",
                userName: isPhoneInput ? loginPhone : loginName,
                isBtnTypeSubmit: Boolean(true),
                disabled: isSubmitting,
                onSubmit: handleSubmit(handleSubmitForm),
                onPasswordless: handlePasswordlessSubmit
            })),
            externalProviders.length && !onlyAdProvider ? /*#__PURE__*/ _jsx(SocialNetworks, {}) : null,
            isJoinUsButtonDisplayed ? /*#__PURE__*/ _jsx(JoinUsLink, {
                variant: "button",
                "data-testid": getTestId('join-us-button'),
                onClick: handleJoinUsRedirect,
                children: /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: defaultTranslations.JoinUs,
                    id: TranslationKey.JoinUs
                })
            }) : null,
            messageBox
        ]
    });
};
export default Login;
